import React from 'react';
import { DeliveryDate } from '_common/components/search/DeliveryDateOptions';

export const DELIVERY_DATE_CONTEXT_DEFAULT = 'DEFAULT' as const;
export const DELIVERY_DATE_CONTEXT_ISOLATED = 'ISOLATED' as const;

export type PageContext =
  | typeof DELIVERY_DATE_CONTEXT_DEFAULT
  | typeof DELIVERY_DATE_CONTEXT_ISOLATED;

type ContextState = {
  pageContext?: PageContext;
  isolatedContextDeliveryDate?: DeliveryDate;
  setIsolatedContextDeliveryDate?: (val: string) => void;
};

const defaultContextState: ContextState = {
  pageContext: DELIVERY_DATE_CONTEXT_DEFAULT
};

export const DeliveryDateContext = React.createContext(defaultContextState);

export const chooseDeliveryDateFromContext = (
  contextState: ContextState,
  deliveryDate: DeliveryDate | undefined
) => {
  return contextState.pageContext === DELIVERY_DATE_CONTEXT_DEFAULT
    ? deliveryDate
    : contextState.isolatedContextDeliveryDate;
};
